import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export function useClientInvoices(customerId) {
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.ClientBillingOverview,
            customerId
        ],
        queryFn: ()=>api.invoice.getInvoicesByCustomer(customerId),
        enabled: customerId != null
    });
    if (customerId == null) {
        return {
            invoices: [],
            isLoading: false,
            isError: false,
            refetch: refresh
        };
    }
    return {
        invoices: data !== null && data !== void 0 ? data : [],
        isLoading,
        isError: error != null,
        refetch: refresh
    };
}
